import { gql } from '__generated__';

export default gql(`
  mutation EditEventSettings($input: EditEventSettingsInput!) {
    editEventSettings(input: $input) {
      ...EventSettingsFields
    }
  }
`);
